import { render, staticRenderFns } from "./CGU.vue?vue&type=template&id=61808378"
import script from "./CGU.vue?vue&type=script&lang=ts"
export * from "./CGU.vue?vue&type=script&lang=ts"
import style0 from "./CGU.vue?vue&type=style&index=0&id=61808378&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./cgu.fr.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc680410044%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2FCGU.vue&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./cgu.en.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc680410044%2Fsrc%2Fgit-codecommit.eu-west-3.amazonaws.com%2Fv1%2Frepos%2Farqana-front-myarqana%2Fsrc%2Fviews%2FCGU.vue&external"
if (typeof block1 === 'function') block1(component)

export default component.exports